import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import { CACHE_KEYS } from '../../types';
import * as api from './api';
import { normalizeTmsSettings } from './normalize';

const fetchTMSSettings = createProvider(api.fetchTMSSettings)
  .andThen((res) => normalizeTmsSettings(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('fetchTMSSettings aborted');
    } else {
      console.error('fetchTMSSettings was failed:', error);
    }
    throw error;
  });

export const getTmsSettingsQueryOptions = (params: Partial<api.GetTMSSettingsRequestParams>) =>
  queryOptions({
    enabled: Boolean(params.customerKey),
    queryFn: ({ signal }) => fetchTMSSettings(params as api.GetTMSSettingsRequestParams, { signal }),
    queryKey: CACHE_KEYS.settings(params.customerKey),
    // biome-ignore lint/style/noMagicNumbers: 10 seconds
    staleTime: 1000 * 10,
  });
